module.exports = __webpack_public_path__ + "static/media/footer.7088ae2f.png";